<template lang="pug">
  main(style="background-color: #fff")
    // Entrance
    section.entrance
      h1.entrance__title {{ $t('mainPage.entrance.title') }}
      .tab.tab_entrance.entrance__tab
        .tab__menu
          button.tab__button(
            :class="{'tab__button_active': currentTab === 'Serial'}"
            @click="currentTab = 'Serial'"
          ) {{ $t('mainPage.entrance.Serial.title') }}
          button.tab__button(
            :class="{'tab__button_active': currentTab === 'Tracking'}" @click="currentTab = 'Tracking'"
          ) {{ $t('mainPage.entrance.Tracking.title') }}
          button.tab__button(
            :class="{'tab__button_active': currentTab === 'Warranty'}" @click="currentTab = 'Warranty'"
          ) {{ $t('mainPage.entrance.Warranty.title') }}
        .tab__container
          transition(name="component-fade" mode="out-in")
            component(:is="currentTabComponent" :windowWidth="windowWidth")
        <router-link class="videoinstruction__open" to="videoinstruction">
          | Как создать заявку
        </router-link>
      Socials.entrance__socials
    // Warranty-service
    WarrantyService#advantage
    // Brands
    SectionBrands#brands
    // Non-warranty-repair
    SectionNonWarrantyRepair#prices
    // Contacts
    section.contacts#contacts
      h2.title {{ $t('mainPage.contacts.title') }}
      ul.contacts__list
        li.contacts__item(v-for="(item, index) in $t('mainPage.contacts.list')" :key="index")
          h3.contacts__subtitle {{ item.title }}
          h4.contacts__description {{ item.subtitle }}
          address.contacts__address(v-if="windowWidth < 1200") {{ item.address}}
            ul.contacts__schedule-list
              li.contacts__schedule-item(v-for="(item, index) in item.shopSchedule" :key="index")
                span.contacts__schedule-week {{ item.week }}
                span.contacts__schedule-time {{ item.time }}
          // Sheet
          address.contacts__address(v-else)
            span
              | {{ item.address.split(' ', 1)[0] }}
              br
              |  {{ item.address.split(' ').splice(1).join(' ') }}
            a(:href="item.map.href" target="_blank").contacts__map {{ item.map.text }}
            ul.contacts__schedule-list
              li.contacts__schedule-item(v-for="(item, index) in item.shopSchedule" :key="index")
                span.contacts__schedule-week {{ item.week }}
                span.contacts__schedule-time {{ item.time }}
          | {{ item.phonesTitle }}
          .contacts__phones
            a.contacts__phone(:href="'tel:' + parsePhone(phone)" v-for="(phone, index) in item.phones" :key="index") {{ phone }}
          ul.contacts__schedule-list
            li.contacts__schedule-item(v-for="(item, index) in item.schedule" :key="index")
              span.contacts__schedule-week {{ item.week }}
              span.contacts__schedule-time {{ item.time }}
    // Banner
    section.banner
      h2.title.banner__title {{ $t('mainPage.banner.title') }}
      .banner__buttons
        a.banner__button(
          @click="currentTab === 'Serial'"
          v-scroll-to="'#header'"
          ) {{ $t('mainPage.entrance.Serial').title }}
        a.banner__button(
          @click="currentTab = 'Tracking'"
          v-scroll-to="'#header'"
        ) {{ $t('mainPage.entrance.Tracking').title }}
</template>

<script>
/* import { ResponsiveDirective } from 'vue-responsive-components' */
import Header from '@/components/Header/Header.vue'
import Socials from '@/components/Socials'
import Footer from '@/components/Footer'
import TabSerial from './TabSerial'
import TabTracking from './TabTracking'
import TabWarranty from './TabWarranty'
import WarrantyService from '@/components/Other/WarrantyService'
import SectionBrands from '@/components/Other/SectionBrands'
import SectionNonWarrantyRepair from '@/components/Other/SectionNonWarrantyRepair'
import { mapGetters } from 'vuex'
import VueScrollTo from 'vue-scrollto'
import Vue from 'vue'
import store from '../store'

Vue.use(VueScrollTo)

function debounce (func) {
  var timer
  return function (event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, 100, event)
  }
}

export default {
  name: 'MainPage',
  data () {
    return {
      currentTab: 'Serial',
      msg: 'Start Project',
      windowWidth: window.innerWidth
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize)
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.$store.dispatch('home/loadContent')
    },
    parsePhone (string) {
      return string.replace(/[^+0-9]/g, '')
    },
    handleResize () {
      return debounce(() => {
        this.windowWidth = window.innerWidth
      })
    },
    handleScroll: debounce(() => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const contentToScroll = document.querySelector('.warranty-service')
      if (scrollTop > contentToScroll.offsetTop - 25) {
        if (this.getChangeLogo !== true) {
          store.dispatch('changeLogo', true)
        }
      } else {
        if (this.getChangeLogo !== false) {
          store.dispatch('changeLogo', false)
        }
      }
    })
  },
  computed: {
    ...mapGetters({
      'getChangeLogo': 'getChangeLogo',
      'content': 'home/getContent'
    }),
    currentTabComponent () {
      return 'Tab' + this.currentTab
    }
  },
  components: {
    Header,
    Socials,
    Footer,
    TabSerial,
    TabTracking,
    TabWarranty,
    WarrantyService,
    SectionBrands,
    SectionNonWarrantyRepair
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: all .3s cubic-bezier(0.645,  0.045, 0.355, 1.000);
  }
  .component-fade-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transform: translateY(50%);
  }
  .component-fade-enter {
    opacity: 0;
    transform: translateY(-30%);
  }
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue